<div
  [hidden]="(filterValue == 'ungraded' && question.PointsEarned != null && question.PointsEarned >= 0 && question.PointsEarned <= question.PointsAvailable) || (isConsumerCurriculum)">
  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title class="panel-title" fxLayout="row">

        <div class=question-title>
          <i class="far fa-check-circle correct-icon" *ngIf="correct != null && correct"></i>
          <i class="far fa-times-circle incorrect-icon" *ngIf="correct != null && !correct"></i>
          {{ question.QuestionTitle }}
        </div>
        <div class="points-status">
          [ {{ (question.PointsEarned == null ? '-' : question.PointsEarned) + ' / ' + question.PointsAvailable }} ]
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="question-text" [innerHTML]="question.QuestionText | safeHtml"></div>

    <div class="panel-body" fxLayout="row">
      <app-question-grading 
      [pointsEarned]="question.PointsEarned" 
      [pointsAvailable]="question.PointsAvailable"
        [questionType]="4" 
        [question]="question"
        (gradeStatusChanges)="gradeStatusChanged($event)"
        (partialCreditChanges)="partialCreditChanged($event)">
      </app-question-grading>
      <div class="response-container">
        <div fxLayout="row">
          <b>Student Response :</b>
          <div class="student-response">
            {{ question.StudentResponse }}
          </div>
        </div>
        <div fxLayout="row">
          <b>Correct Answers :</b>
          <div class="answer" *ngFor="let answer of question.AvailableResponses">
            {{ answer.Response }}
          </div>
        </div>
      </div>
    </div>
  </mat-expansion-panel>

</div>
